import React from "react";
import { useLanguage } from "../context/LanguageContext";
import Hero from "../components/Hero";
import Services from "../components/Services";
import Contact from "../components/Contact";
import heroImage from "../img/HEROHOME.png";
import BannerEditorial from "../components/BannerEditorial";
import BannerFestival from "../components/BannerFestival";

const translations = {
  ES: {
    heroTitle: "La creatividad del territorio",
    heroDescription:
      "Conectamos personas, sabores e ideas con raíces ampurdanesas.",
  },
  CAT: {
    heroTitle: "La creativitat del territori",
    heroDescription:
      "Connectem persones, sabors i idees amb arrels empordaneses",
  },
};

const Home = ({ contactRef }) => {
  const { language } = useLanguage();
  const { heroTitle, heroDescription } = translations[language];

  return (
    <div>
      <Hero
        title={heroTitle}
        description={heroDescription}
        backgroundImage={heroImage}
      />
      <Services />
      <BannerEditorial />
      <BannerFestival />
      <Contact contactRef={contactRef} />
    </div>
  );
};

export default Home;
